<af-main-container #mainContainer
                   [title]="'i18n_lib_breadcrumb#EditClassification' | translate"
                   [showBreadcrumbs]="true"
                   [buttonDisabled]="true"
                   [specialFilter]="specialFilter"
                   [breadcrumbCustomizer]="breadcrumbCustomizer"
                   [tabPathToTab]="tabPathToTab">
    @if (form) {
        <form class="w-100 bc-mono-white radius-16 p-24 mt-24" [formGroup]="form"
              fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="24px"
              (submit)="publish()">

            @if (form.controls.description) {
                <div fxLayout="column" fxLayoutAlign="start start" class="w-824">
                    <div class="t5 c-primary-gray-600">{{ 'i18n_af_labelDescriptionClassification' | translate }}*</div>
                    <mat-form-field class="mt-4 w-100"
                                    [class.value-not-empty]="form.enabled && form.value.description">
                        <textarea matInput
                                  #descriptionArea
                                  [maxlength]="DESCRIPTION_MAX_LENGTH"
                                  class="resize-none pt-12 pb-12"
                                  (keydown.control.enter)="form.valid"
                                  [placeholder]="'i18n_af_placeholderTypeText' | translate"
                                  [formControl]="form.controls.description"></textarea>
                        <mat-hint align="start" class="t5 c-primary-gray-600">{{ descriptionArea.value.length }}
                            / {{ DESCRIPTION_MAX_LENGTH }}
                        </mat-hint>
                    </mat-form-field>
                </div>
            }

            @if (form.controls.implementationForm) {
                <div fxLayout="column" fxLayoutAlign="start start" class="w-824">
                    <div class="t5 c-primary-gray-600">{{ 'i18n_af_labelImplementationForm' | translate }}*</div>
                    <mat-form-field class="mt-4 w-100"
                                    [class.value-not-empty]="form.enabled && form.value.implementationForm">
                        <textarea matInput
                                  #implementationFormArea
                                  [maxlength]="DESCRIPTION_MAX_LENGTH"
                                  class="resize-none pt-12 pb-12"
                                  (keydown.control.enter)="form.valid"
                                  [placeholder]="'i18n_af_placeholderTypeText' | translate"
                                  [formControl]="form.controls.implementationForm"></textarea>
                        <mat-hint align="start" class="t5 c-primary-gray-600">{{ implementationFormArea.value.length }}
                            / {{ DESCRIPTION_MAX_LENGTH }}
                        </mat-hint>
                    </mat-form-field>
                </div>
            }

            @if (form.controls.implementationMethod) {
                <div fxLayout="column" fxLayoutAlign="start start">
                    <div class="t5 c-primary-gray-600">{{ 'i18n_af_labelImplementationMethod' | translate }}*</div>
                    <div class="editor-container custom-input mt-4 w-824" fxLayout="column">
                        <ngx-editor-menu [editor]="editor" [toolbar]="NGX_EDITOR_DEFAULT_TOOLBAR"
                                         class="pl-16 pr-16 pt-16"></ngx-editor-menu>
                        <ngx-editor class="h-100 overflow-y-scroll" [editor]="editor"
                                    [placeholder]="'i18n_af_placeholderTypeText' | translate"
                                    [formControl]="form.controls.implementationMethod">
                        </ngx-editor>
                    </div>
                </div>
            }

            @if (form.controls.recommendations) {
                <div fxLayout="column" fxLayoutAlign="start start" class="w-824">
                    <div class="t5 c-primary-gray-600">{{ 'i18n_af_labelRecommendations' | translate }}*</div>
                    <mat-form-field class="mt-4 w-100"
                                    [class.value-not-empty]="form.enabled && form.value.recommendations">
                        <textarea matInput
                                  #recommendationsArea
                                  [maxlength]="DESCRIPTION_MAX_LENGTH"
                                  class="resize-none pt-12 pb-12"
                                  (keydown.control.enter)="form.valid"
                                  [placeholder]="'i18n_af_placeholderTypeText' | translate"
                                  [formControl]="form.controls.recommendations"></textarea>
                        <mat-hint align="start" class="t5 c-primary-gray-600">{{ recommendationsArea.value.length }}
                            / {{ DESCRIPTION_MAX_LENGTH }}
                        </mat-hint>
                    </mat-form-field>
                </div>
            }
            <div fxLayout="row" fxLayoutAlign="start center" class="mt-16">
                <ui-kit-button spinnerId="submit"
                               [disabled]="form.invalid"
                               [label]="'i18n_af_buttonPublish' | translate"/>
                <ui-kit-button class="ml-16"
                               color="accent"
                               buttonType="button"
                               type="text"
                               (clickListener)="cancel()"
                               [label]="'i18n_af_buttonCancel' | translate"/>
            </div>
        </form>
    }
</af-main-container>
